<template>
  <div>

    <Hero>
      Найди лучшую работу
      <em>
        в твоей жизни
      </em>
    </Hero>

    <section :class="$style.container">
      <h2 :class="$style.heading">
        Карьера
      </h2>

      <ul
        :class="$style.buttonsList"
      >
        <li
          v-for="(city, index) in cities"
          :key="index"
        >
          <router-link
            :to="{ path: '/join', query: { city: city.url }}"
            :class="[$style.button, {[$style.buttonActive]: currentCity === city.url }, 'hover-scale']"
          >
            {{ city.nameRU }}
          </router-link>
        </li>

      </ul>

      <ul
        v-if="renderJobs"
        :class="$style.list"
      >
        <li
          v-for="job in filteredJobs"
          :key="job.id"
          :class="$style.listItem"
        >
          <div
            :class="[
              $style.item,
              { [$style.closed]: isJobClosed(job.status) }
            ]"
          >
            <router-link
              :to="{ path: '/job/', query: { city: job.url, job: job.board_code }}"
              :class="$style.link"
            >
              <div :class="$style.title">{{ job.title | jobTitle }}</div>
              <span :class="$style.linkText">
                Подробнее
              </span>
            </router-link>
          </div>
        </li>
      </ul>
    </section>

    <OurHRs />
  </div>
</template>

<script>
import Hero from 'components/Hero';
import OurHRs from 'components/OurHRs';
import { mapGetters } from 'vuex';
import { GET_CITIES, GET_JOBS } from 'store/getters';
import jobStatuses from 'constants/jobStatuses';

export default {
  name: 'JoinToTeam',
  components: {
    Hero,
    OurHRs,
  },
  filters: {
    jobTitle: title => title.replace('(RU)', ''),
  },
  computed: {
    currentCity() {
      return this.$route.query.city || 'ekaterinburg';
    },
    ...mapGetters({
      jobs: GET_JOBS,
      cities: GET_CITIES,
    }),
    renderJobs() {
      return !!this.currentCity;
    },
    filteredJobs() {
      if (this.cities.length === 0) {
        return false;
      }

      const currentCityUrl = this.currentCity;

      const currentCity = this.cities.filter(
        city => city.url === currentCityUrl,
      )[0].name;

      const filteredJobs = [...this.jobs];
      const newFilteredJobs = filteredJobs.filter(
        job => job.city.split(', ').indexOf(currentCity) !== -1,
      );

      const openJobs = newFilteredJobs.filter(
        job => !this.isJobClosed(job.status),
      );

      const closedJobs = newFilteredJobs.filter(job =>
        this.isJobClosed(job.status),
      );

      return openJobs.concat(closedJobs);
    },
  },
  methods: {
    isJobClosed(status) {
      return status === jobStatuses.closed;
    },
  },
};
</script>

<style lang="scss" module>
@import '~styles/variables';
@import '~styles/helpers';
@import '~styles/mixins';

.container {
  @extend %container;
  @extend %section;
  padding-bottom: 160px;
  border-bottom: 0;
}

.heading {
  @extend %heading;
}

.list {
  display: flex;
  flex-flow: row wrap;
  list-style-type: none;
  padding: 0;
  margin: 0 -1%;
  animation: fadeEff $transitions-delay;
}

.listItem {
  flex-basis: 33.33%;
  padding: $grid-gutter;

  @include media('<tablet') {
    padding: $grid-gutter-mobile;
  }

  @include media('<desktop') {
    flex-basis: 50%;
  }

  @include media('<tablet') {
    flex-basis: 100%;
    padding: $grid-gutter-mobile/2 $grid-gutter-mobile;
  }
}

.item {
  /* stylelint-disable*/

  $shadow: rgba(2, 2, 2, 0.25);
  height: 172px;
  border: 1px solid $gray-2;
  border-radius: 4px;
  background-color: $white;
  box-shadow: inset 0 1px 2px 0 $shadow;
  overflow: hidden;
  transition: border 0.3s, background 0.3s, box-shadow 0.3s;
  position: relative;

  @include media('<tablet') {
    height: 80px;
  }

  @include on-event {
    border-color: $red-light;
    background-color: $white-gray;

    .title {
      @include media('<tablet') {
        color: $red-light;
      }
    }
  }
}

.closed {
  background-color: #bdbdbd;

  @include on-event {
    border-color: #808080;
    background-color: #bdbdbd;
  }
}

.link {
  @extend %hoverBlock;

  width: 100%;
  height: 100%;
  text-decoration: none;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  text-align: center;

  @include media('<tablet') {
    padding: 10px 40px;

    .linkText {
      opacity: 0;
    }
  }
}

.linkText {
  opacity: 0;
  font-size: 12px;
  line-height: 17px;
  font-weight: 600;
  margin-top: 15px;
  letter-spacing: 0.75px;
  text-transform: uppercase;
  color: $red-light;
  text-decoration: none;

  @include media('<tablet') {
    position: absolute;
    opacity: 0;
    margin-top: 0;
  }
}

.title {
  font-size: 24px;
  line-height: 30px;
  color: $gray-dark;
  margin-top: 32px;
  transition: opacity $transitions-delay;

  @include media('<tablet') {
    margin-top: 0;
    font-size: 20px;
    line-height: 26px;
  }
}

.buttonsList {
  display: flex;
  justify-content: center;
  margin-bottom: 65px;
  list-style-type: none;
  padding: 0;
  flex-wrap: wrap;

  @include media('<desktop') {
    justify-content: center;
  }
}

.button {
  text-decoration: none;
  margin: 0 15px;
  padding: 15px 25px;
  border: 2px solid $transparent;
  border-radius: 50px;
  outline: none;
  background-color: $transparent;
  font-size: 14px;
  line-height: 19px;
  font-weight: 600;
  color: $gray-3;
  text-transform: uppercase;
  cursor: pointer;
  transition: color 0.3s, border 0.3s;
  display: block;
  margin-bottom: 10px;

  @include media('<tablet') {
    padding: 10px 12px;
    margin: 0 5px;
  }

  @include on-event {
    $gray-darken: darken($gray-3, 10%);
    color: $gray-darken;
  }
}

.buttonActive {
  border: 2px solid $red-light;
  border-radius: 50px;
  color: $red-light;

  @include on-event {
    $red-light-darken: darken(#f75050, 10%);

    color: $red-light-darken;
    border-color: $red-light-darken;
  }
}

@keyframes fadeEff {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/JoinToTeam.vue